/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartSimplifyAllTaskRequest
 */
export interface StartSimplifyAllTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof StartSimplifyAllTaskRequest
     */
    externalCommunicationId?: string;
}

export function StartSimplifyAllTaskRequestFromJSON(json: any): StartSimplifyAllTaskRequest {
    return StartSimplifyAllTaskRequestFromJSONTyped(json, false);
}

export function StartSimplifyAllTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartSimplifyAllTaskRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalCommunicationId': !exists(json, 'externalCommunicationId') ? undefined : json['externalCommunicationId'],
    };
}

export function StartSimplifyAllTaskRequestToJSON(value?: StartSimplifyAllTaskRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalCommunicationId': value.externalCommunicationId,
    };
}


